export const FILTER_CONDITIONS = [
  { label: "includes", value: "includes" },
  { label: "is", value: "is" },
  { label: "excluding", value: "excluding" },
];

export const FILTER_OPERATIONS = [
  { label: "AND", value: "and" },
  { label: "OR", value: "or" },
];
